import { Box } from '@material-ui/core'
import PDF from '../../svgs/pdf'
import DownloadForm from '../DownloadForm'
import { useStyles } from './styles'
const UploadFileView = (props) => {
  const { uploadfiledescription, PDFViewLink } = props
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      <PDF height="65px" width="65px"></PDF>
      <Box className={classes.uploadfiledescription}>
        {uploadfiledescription}
      </Box>
      <Box className={classes.textlayout}>
        {' '}
        <Box className={classes.text}>
          <DownloadForm PDFViewLink={PDFViewLink}></DownloadForm>
        </Box>
      </Box>
    </div>
  )
}
export default UploadFileView
